import React from 'react';
import Icon from 'b3/icons/Icon';
import Avatar from 'b3/avatar/Avatar';
import { Flex } from 'c3';
import './contactCard.less';
import gravatar from 'gravatar';

export default class ContactCard extends React.Component {
	static defaultProps = {
		onClick: () => {},
		openEditModal: false
	};
	render() {
		var { contact, openEditModal } = this.props;
		var name, description;
		var gravatarEmail = '';
		var phones = []; 
		var mobiles = []; 
		var emails = [];

		if(this.props.contact){
			name 		= contact.firstName + " " + contact.lastName;
			description = contact.description ? ("( " + contact.description + " )") : '';
			phones		= contact.numbers ? contact.numbers : [];
			mobiles		= contact.mobiles ? contact.mobiles : [];
			emails 		= contact.emails  ? contact.emails  : [];
			gravatarEmail = contact.emails && contact.emails.length ? contact.emails[0].email : '';
		}

		return(
			<div className="contactCard component__contactCard" style={this.props.style} onClick={this.props.onClick.bind(this, contact)}>
				{openEditModal &&
					<i onClick={openEditModal} className="fa fa-pencil contactCard__editIcon"></i>
				}
				<div className="contactCard__avatar">
					<Avatar avatar={gravatar.url(gravatarEmail, {s: 50, d: 'retro'}, true)} size={50}/>
				</div>
				
				<div className="contactCard__content">
					<h2>{name} <span className="contactCard__title">{description}</span></h2>
					<p>
						{phones.map(({number}, i) =>
							<span key={i} className="contactCard__phone"> <Icon icon="call-1" filled/> {number}</span>
						)}
						{mobiles.map(({number}, i) =>
							<span key={i} className="contactCard__mobile"><Icon icon="smartphone" filled/> {number}</span>
						)}
					</p>
					<Flex>
						{emails.map(({email}, i) =>
							<span key={i} className="contactCard__email">
								<Icon icon="mail-1" filled/> <span style={{marginRight: 10}}>{email}</span>
							</span>
						)}
					</Flex>
				</div>

				{this.props.showCaret && <span className="contactCard__caret" ><i className="fa fa-caret-down"></i></span>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./app/components/contact-card/ContactCard.js